import React from 'react';
import BaseModal, {
	BaseModalProps,
} from '../../../Base/Components/BaseModal/BaseModal';
import InsuranceCompanyInsuranceExportGen from './InsuranceCompanyInsuranceExportGen';
import { Size } from '../../../../Enums/Size.enum';

interface Props extends BaseModalProps {
	rootWorkplaceId: string;
}

const InsuranceCompanyInsuranceExportGenModal: React.FC<Props> = props => {
	return (
		<BaseModal
			title='component.insuranceCompanyInsuranceExportGenModal.title'
			{...props}
			size={Size.SM}>
			<InsuranceCompanyInsuranceExportGen
				rootWorkplaceId={props.rootWorkplaceId}
				onSuccess={props.onClose}
			/>
		</BaseModal>
	);
};

export default InsuranceCompanyInsuranceExportGenModal;
